// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Live mirror of the Amy composer's unsent text (acceptance 4, 2026-09-04).
 *
 * The shell needs the draft at the ONE moment it performs its own explicit
 * reload (reload-before-prefill, lib/amyPrefillHandoff.ts) — without
 * threading composer state through the drawer. AmyChat writes here on every
 * change and clears on unmount; nothing else reads it. Module state, not
 * storage: it never outlives the page by itself.
 */

let liveDraft = ""

export function noteAmyDraft(text: string): void {
  liveDraft = text
}

export function peekAmyDraft(): string {
  return liveDraft
}

export function clearAmyDraft(): void {
  liveDraft = ""
}
